import RedoRoundedIcon from "@mui/icons-material/RedoRounded";
import UndoRoundedIcon from "@mui/icons-material/UndoRounded";
import { IconButton, Stack } from "@mui/material";
import TooltipForDisabledAction from "@entrilia/shared/components/TooltipForDisabledAction";
import { useAppDispatch } from "../../../store/hooks/useAppDispatch";
import { useAppSelector } from "../../../store/hooks/useAppSelector";
import { selectCanRedo, selectCanUndo } from "../../../store/selectors/editingHistorySelectors";
import { redoEditing, undoEditing } from "../../../store/thunks/editingHistoryThunks";

const EditingHistoryControls = () => {
  const dispatch = useAppDispatch();
  const canUndo = useAppSelector(selectCanUndo);
  const canRedo = useAppSelector(selectCanRedo);

  const handleUndoClick = () => dispatch(undoEditing());
  const handleRedoClick = () => dispatch(redoEditing());

  return (
    <Stack direction="row">
      <TooltipForDisabledAction title="Undo" isActionDisabled={!canUndo}>
        <IconButton aria-label="Undo" disabled={!canUndo} onClick={handleUndoClick}>
          <UndoRoundedIcon />
        </IconButton>
      </TooltipForDisabledAction>
      <TooltipForDisabledAction title="Redo" isActionDisabled={!canRedo}>
        <IconButton aria-label="Redo" disabled={!canRedo} onClick={handleRedoClick}>
          <RedoRoundedIcon />
        </IconButton>
      </TooltipForDisabledAction>
    </Stack>
  );
};

export default EditingHistoryControls;
